import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, BoxProps, Stack, styled, Typography } from '@mui/material';

export type BooleanValueDisplayProps = {
  label?: boolean;
  value: boolean;
};

export const Indicator = styled(({ value, ...props }: BoxProps & BooleanValueDisplayProps) => (
  <Box {...props} />
))`
  background: ${({ theme, value }) =>
    value ? theme.palette.success.main : theme.palette.error.main};
  height: 8px;
  width: 8px;
  border-radius: 8px;
`;

export const BooleanValueDisplay: FC<BooleanValueDisplayProps> = ({ value }) => {
  const { t } = useTranslation();

  return (
    <Stack alignItems='center' direction='row' spacing={1}>
      <Indicator value={value} />
      <Typography variant='inherit'>{value ? t('yes') : t('no')}</Typography>
    </Stack>
  );
};
